import React, { FC, PropsWithChildren, ReactNode, useCallback, useEffect, useState } from 'react'
import { Button, Card, Radio, Select } from 'antd'

type PropType = FC<PropsWithChildren<{
  title?: string
  tabs?: { label: string, value: string }[]
  className?: string
  hasExport?: boolean
  hasDepartSelect?: boolean
  onTabChange?: (value: {tab: string, depart?: string}) => void
  customFilter?: ReactNode
}>>

const Component: PropType = ({ title, tabs, className, children, hasExport, hasDepartSelect, customFilter, onTabChange }) => {
  const [departOptions, setDepartOptions] = useState([])
  const [depart, setDepart] = useState('')
  const [tabValue, setTabValue] = useState(tabs && tabs[0] && tabs[0].value)

  const handleTabChange = useCallback((e) => {
    setTabValue(e.target.value)
  }, [])

  const handleDepartChange = useCallback((e) => {
    setDepart(e)
  }, [])

  useEffect(() => {
    if(hasDepartSelect) {
      if(depart && tabValue) {
        if(typeof onTabChange === 'function') {
          onTabChange({
            tab: tabValue,
            depart
          })
        }
      }
    } else {
      if(tabValue) {
        if(typeof onTabChange === 'function') {
          onTabChange({
            tab: tabValue,
          })
        }
      }
    }
  }, [hasDepartSelect, depart, tabValue, onTabChange])

  useEffect(() => {
    if(hasDepartSelect) {
      setDepartOptions([{label: '能源所', value: '1'}, {label: '产品所', value: '2'}])
      setDepart('1')
    }
  }, [hasDepartSelect])

  return (
    <div className={`flex h-full flex-column ${className}`}>
      <div className='flex align-center'>
        {
          title && <div className='font-14 font-700 mr-20'>{title}</div>
        }
        {
          tabs && tabs[0] && <Radio.Group onChange={handleTabChange} size='small' optionType="button" options={tabs} value={tabValue} />
        }
        {
          hasDepartSelect && (
            <div className='ml-10'>
              <Select value={depart} onChange={handleDepartChange} size='small'>
                {
                  departOptions.map(o => <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>)
                }
              </Select>
            </div>
          )
        }
        {
          customFilter
        }
        <div className='flex-1'></div>
        {
          hasExport !== false && <Button type='primary' size='small'>导出Excel</Button>
        }
      </div>
      <div className='flex-1 h-0'>
        {
          children
        }
      </div>
    </div>
  )
}

export default Component
